import { Label, Switch } from '@/components'
import { cn } from '@/lib/utils'
import React from 'react'

export const SettingRow: React.FC<{
  id: string
  label: string
  description?: string
  info?: string
  checked: boolean
  className?: string
  onCheckedChange: (checked: boolean) => void
}> = ({
  id,
  label,
  description,
  info,
  checked,
  className,
  onCheckedChange,
}) => (
  <div className={cn('flex items-center justify-between gap-6', className)}>
    <div className="space-y-1">
      <Label htmlFor={id} info={info} className="text-stone-900 leading-snug">
        {label}
      </Label>
      {description && <p className="text-sm text-stone-500">{description}</p>}
    </div>
    <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
  </div>
)
